/**
 * Constants used throughout the workers-channel client
 */

// Message Types
const MESSAGE_TYPES = {
  MESSAGE: 'message',
  REQUEST: 'request',
  RESPONSE: 'response',
}

// Client States
const CLIENT_STATES = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
}

// Encoding Formats
const ENCODING_FORMATS = {
  HEX: 'hex',
  BASE64: 'base64',
}

// Cryptography Constants
const CRYPTO_CONSTANTS = {
  IV_LENGTH: 12, // AES-GCM standard IV length (96 bits)
  AES_KEY_LENGTH: 32, // AES-256 key length (256 bits / 8 = 32 bytes)
  SALT_LENGTH: 32, // 256-bit salt for HKDF
  ED25519_PUBLIC_KEY_LENGTH: 32, // Ed25519 public key length
  ED25519_PRIVATE_KEY_LENGTH: 32, // Ed25519 private key length
}

// Timeouts and Intervals
const TIMING_CONSTANTS = {
  DEFAULT_CALL_TIMEOUT: 120 * 1000, // 120 seconds
  DEFAULT_HTTP_CALL_TIMEOUT: 60 * 1000, // 60 seconds (for HTTP mode)
  DEFAULT_CONSUME_INTERVAL: 15000, // 15 seconds
  WEBSOCKET_KEEPALIVE_INTERVAL: 20000, // 20 seconds
  WEBSOCKET_RECONNECT_DELAY: 1000, // 1 second
  MESSAGE_EXPIRE_TIME: 2 * 60 * 1000, // 2 minutes
}

// Transport Modes
const TRANSPORT_MODES = {
  WS: 'ws', // WebSocket only
  HTTP: 'http', // HTTP only
  AUTO: 'auto', // Auto-select (prefer WS, fallback to HTTP)
}

// Special call targets
const LOCAL_CALL_TARGET = 'local'

// Error Codes
const ERROR_CODES = {
  SUCCESS: 0,
  INTERNAL_ERROR: 500,
  TIMEOUT: 408,
  NOT_FOUND: 404,
  VALIDATION_ERROR: 400,
}

module.exports = {
  MESSAGE_TYPES,
  CLIENT_STATES,
  ENCODING_FORMATS,
  CRYPTO_CONSTANTS,
  TIMING_CONSTANTS,
  TRANSPORT_MODES,
  ERROR_CODES,
  LOCAL_CALL_TARGET,
}
